import { render, staticRenderFns } from "./AddRecipient.vue?vue&type=template&id=1dceda68&scoped=true&"
import script from "./AddRecipient.vue?vue&type=script&lang=js&"
export * from "./AddRecipient.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddRecipient.vue?vue&type=style&index=1&id=1dceda68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dceda68",
  null
  
)

export default component.exports